<template>
  <div class="centivo notification-dashboard">
    <div class="dashboard-title">Notifications</div>
    <!-- <div class="dashboard-title">{{this.clientName}}</div>
    <div class="dashboard-title">{{this.planBasicInfo.planId}}</div> -->

    <div
      v-if="getShowWarningModal"
      class="modal"
      id="modal-warning"
      @click="handleModelClick"
    >
      <div class="modal-content">
        <p class="modal-title">Submit your changes?</p>
        <p class="modal-text">
          Go to the notifications tab to submit your changes. If you do not
          click on the submit button on the notifications tab, your changes will
          not be saved.
        </p>

        <button
          class="btn-primary"
          @click="() => updateShowWarningModal(false)"
        >
          Yes, I want to submit my changes
        </button>
        <button class="btn-primary-outline" @click="goHome">
          No, I don't want to submit my changes
        </button>
      </div>
    </div>

    <!-- <h3>{{ planUuid }}</h3> -->
    <!-- <input type="text" @input="updateMessage" /> -->
    <div class="tabs">
      <div
        v-for="(tab, index) in tabs"
        :key="tab.title"
        @click="
          Object.keys(isVaiablesFormValid).length === 0 && selectTab(index)
        "
        :class="[
          'tab',
          index == selectedTabIndex && 'tab-selected',
          Object.keys(isVaiablesFormValid).length === 0 && 'tab-enabled',
        ]"
      >
        {{ tab.label }}
      </div>

      <div class="client-plan-display">
        {{ this.planBasicInfo.clientName + " / " + this.planBasicInfo.planId }}
      </div>
    </div>

    <div v-if="selectedTabIndex === 0" class="variables">
      <div class="tab-action">
        <div class="tab-helper-text">
          You must enter all input fields below to activate the notifications
          tab
        </div>
      </div>

      <div class="panels">
        <div class="panel">
          <div class="left">
            <div class="title">
              <p>Customizable variables</p>
            </div>
            <div class="title-helper-text">
              <span>* </span>
              <span> All fields below are required </span>
            </div>
            <div class="form-container">
              <!-- <form @submit="handleSubmit"> -->
              <form>
                <div class="language-selector">
                  <div class="subtitle">
                    <p>Language</p>
                  </div>
                  <div class="helper-text">
                    <p>
                      All electronic communications are in English only. Paper
                      communications can be turned on in English + Spanish at
                      the plan level (not at the individual member level).
                    </p>
                  </div>
                  <div class="language-options">
                    <div
                      v-for="{ title, isSelected } in languages"
                      :key="title"
                      class="language-option"
                    >
                      <InputComponent
                        :modelValue="isSelected"
                        @update:modelValue="onChangeHandler"
                        :label="title"
                        type="checkbox"
                        id="languages"
                        :name="title"
                      />
                    </div>
                  </div>
                </div>

                <DropDownComponent
                  name="commsLibraryOptions"
                  label="Comms Library"
                  :options="commsLibraryOptions"
                  @update:selectedOption="onChangeHandler"
                  helperText="Choose which communications library applies for this plan."
                />

                <InputComponent
                  :modelValue="clientName"
                  @update:modelValue="onChangeHandler"
                  label="Client name"
                  name="clientName"
                  :error="errors['clientName']"
                  helper-text="This is how the client's name will be displayed in member communications."
                  placeholder="Enter external friendly client name"
                />

                <DropDownComponent
                  name="administratorName"
                  label="Administrator Name"
                  :options="administratorName"
                  @update:selectedOption="onChangeHandler"
                  helperText="This is the brand that the plan is being offered under and will display in communications."
                />

                <DropDownComponent
                  name="supportTeamName"
                  label="Support team name"
                  :options="supportTeamName"
                  @update:selectedOption="onChangeHandler"
                  helperText="This is the name the client uses to refer to the member support team."
                />

                <DropDownComponent
                  name="networkNames"
                  label="Network name"
                  :options="networkNames"
                  @update:selectedOption="onChangeHandler"
                  @update:customInputOption="customInputInDropDownHandler"
                  helperText="This is the name of the network that will appear in certain member communications."
                  :disabled="isPartnershipPlan"
                  :resetSearchText="resetSearchText"
                />

                <!-- <pre>{{JSON.stringify(commsLibraryOptions.find(com => com.isSelected), null, 2)}}</pre> -->
              </form>
            </div>
          </div>
          <div class="right">
            <div class="title">
              <p>Auto populated variables</p>
            </div>
            <div class="title-helper-text">
              <p>
                You cannot edit these inputs in this section. If these require
                editing, go back to the plan configuration and make these
                changes in the original fields.
              </p>
            </div>

            <div class="form-container">
              <form @submit="handleSubmit">
                <InputComponent
                  :modelValue="planName"
                  @update:modelValue="onChangeHandler"
                  label="Plan name"
                  name="planName"
                  :error="errors['planName']"
                  helper-text="This is the external plan name that should match what's being used in all member communications (not what is in Javalina)"
                  disabled
                />

                <InputComponent
                  :modelValue="phoneNumberMemberServices"
                  @update:modelValue="onChangeHandler"
                  label="Contact us phone number"
                  name="phoneNumberMemberServices"
                  :error="errors['phoneNumberMemberServices']"
                  helper-text="This is the client specific member support number."
                  disabled
                />

                <InputComponent
                  :modelValue="supportHours"
                  @update:modelValue="onChangeHandler"
                  label="Member care hours"
                  name="supportHours"
                  :error="errors['supportHours']"
                  helper-text="These are the hours that the member support team is available, displayed in the client's local time zone."
                  disabled
                />

                <InputComponent
                  :modelValue="textCode"
                  @update:modelValue="onChangeHandler"
                  label="Text code"
                  name="textCode"
                  :error="errors['textCode']"
                  helper-text="5-digit code that members will text to download the app."
                  disabled
                />

                <InputComponent
                  :modelValue="textWord"
                  @update:modelValue="onChangeHandler"
                  label="Text word"
                  name="textWord"
                  :error="errors['textWord']"
                  helper-text='The key word that members will text to the "Text code" to receive the correct app download link.'
                  disabled
                />

                <InputComponent
                  :modelValue="portalUrl"
                  @update:modelValue="onChangeHandler"
                  label="URL"
                  name="portalUrl"
                  :error="errors['portalUrl']"
                  helper-text="This is the member portal URL, to be included in communications."
                  disabled
                />
              </form>
            </div>
            <!-- <div class="subtitle">
        <p>All fields below are required</p>
      </div> -->
          </div>
        </div>
        <div class="divider"></div>
        <div class="panel">
          <div class="full">
            <div class="title">
              <p>Partnership Plan variables</p>
            </div>
            <div class="title-helper-text">
              <span>* </span>
              <span>
                All fields below are required. The following variables are used
                in Partnership Plan communications. This is driven off the
                communications library selected above. If the plan is not a
                Partnership Plan, select a different communications library.
              </span>
            </div>
            <div class="form-container">
              <form>
                <DropDownComponent
                  name="pcpCopay"
                  label="PCP copay"
                  :options="pcpCopay"
                  @update:selectedOption="onChangeHandler"
                  @update:customInputOption="customInputInDropDownHandler"
                  helperText='If the PCP visits are a $0 copay, this value should be "FREE" unless the client requests to put "$0" instead.'
                  :disabled="!isPartnershipPlan"
                />
              </form>

              <div class="mini-divider"></div>

              <div class="title-helper-text">
                <p>
                  The following variables are used to describe services that do
                  NOT require a referral. This will be included in a reminder
                  for members to get referrals. Please use the defaults provided
                  below, unless the client has asked for customization to the
                  language.
                </p>
              </div>

              <div class="referral-bullets">
                <div
                  v-for="{ title, options } in referralOptions"
                  :key="title"
                  class="referral-bullet"
                >
                  <div class="subtitle">
                    <p>{{ title }}</p>
                  </div>
                  <!-- <pre>{{JSON.stringify(options, null, 2)}}</pre> -->
                  <form>
                    <InputComponent
                      :modelValue="isSelected"
                      @update:modelValue="onChangeHandler"
                      :label="label.title"
                      :helperText="label.helperText"
                      type="checkbox"
                      :id="title"
                      :name="label.title"
                      :customValue="value"
                      :isCustomInput="isCustomInput"
                      :disabled="isPcpCopaySelected"
                      v-for="{
                        label,
                        isCustomInput,
                        value,
                        isSelected,
                      } in options"
                      :key="label.title"
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="divider"></div>
        <div class="panel">
          <div class="full">
            <div class="title">
              <p>RBP</p>
            </div>

            <div class="form-container">
              <!-- <form @submit="handleSubmit"> -->
              <form>
                <div class="language-selector rbp-selector">
                  <div class="label">Does this plan include RBP?</div>

                  <div class="language-options">
                    <div
                      v-for="{ title, isSelected } in rbpOptions"
                      :key="title"
                      class="language-option"
                    >
                      <InputComponent
                        :modelValue="isSelected"
                        @update:modelValue="onChangeHandler"
                        :label="title"
                        type="checkbox"
                        id="rbpOptions"
                        :name="title"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="mini-divider" style="margin: 0px 0px 30px 0px"></div>

            <div class="title-helper-text" style="margin: 0px 0px 20px 0px">
              <p>
                RBP language for "New claim details available" communication
              </p>
            </div>

            <div class="form-container">
              <!-- <form @submit="handleSubmit"> -->
              <form>
                <div class="language-selector rbp-selector">
                  <div class="label">New claim details available</div>

                  <div class="language-options">
                    <div
                      v-for="{ title, isSelected } in claimDetailsLanguage"
                      :key="title"
                      class="language-option"
                    >
                      <InputComponent
                        :modelValue="isRbpOptionsYes && isSelected"
                        @update:modelValue="onChangeHandler"
                        :label="updateClaimDetailsLanguageTitle(title)"
                        type="checkbox"
                        id="claimDetailsLanguage"
                        :name="title"
                        :disabled="!isRbpOptionsYes"
                      />
                    </div>
                  </div>
                </div>
                <!-- <pre>{{ JSON.stringify(isRbpOptionsYes, null, 2) }}</pre>
      <pre>{{ JSON.stringify(claimDetailsLanguage, null, 2) }}</pre> -->
                <InputComponent
                  :modelValue="claimDetailsLanguageTextareaValue"
                  @update:modelValue="onChangeHandler"
                  :isTextarea="true"
                  :disabled="
                    !isRbpOptionsYes ||
                    !claimDetailsLanguage.some((obj) => obj.isSelected)
                  "
                  id="claimDetailsLanguage"
                  name="claimDetailLanguage"
                  :helperText="
                    claimDetailsLanguage.find((obj) => obj.isSelected)
                      ? claimDetailsLanguage.find((obj) => obj.isSelected)
                          .helperText
                      : ''
                  "
                />
              </form>
            </div>

            <div class="mini-divider" style="margin: 0px 0px 20px 0px"></div>

            <div class="title-helper-text">
              <p>
                This is language specific to a Partnership Plan with a PCP
                network and RBP for specialists. This is customizable language
                that can be used to direct the member as to how to find a
                specialist for their needs.
              </p>
            </div>

            <div class="form-container-wrapper">
              <div class="form-container" style="margin: 20px 0px 20px 0px">
                <form>
                  <div class="language-selector rbp-selector">
                    <div class="label">Self referral</div>

                    <div class="language-options">
                      <div
                        v-for="{ title, isSelected } in selfReferral"
                        :key="title"
                        class="language-option"
                      >
                        <InputComponent
                          :modelValue="isRbpOptionsYes && isSelected"
                          @update:modelValue="onChangeHandler"
                          :label="title"
                          type="checkbox"
                          id="selfReferral"
                          :name="title"
                          :disabled="!isRbpOptionsYes"
                        />
                      </div>
                    </div>
                  </div>
                  <InputComponent
                    :modelValue="selfReferralTextareaValue"
                    @update:modelValue="onChangeHandler"
                    :isTextarea="true"
                    :disabled="
                      !isRbpOptionsYes ||
                      !selfReferral.some((obj) => obj.isSelected)
                    "
                    id="selfReferral"
                    name="selfReferral"
                    :helperText="
                      selfReferral.find((obj) => obj.isSelected)
                        ? selfReferral.find((obj) => obj.isSelected).helperText
                        : ''
                    "
                  />
                </form>
              </div>
              <div class="form-container" style="margin: 20px 0px 20px 0px">
                <form>
                  <div class="language-selector rbp-selector">
                    <div class="label">Dependent referral</div>

                    <div class="language-options">
                      <div
                        v-for="{ title, isSelected } in dependentReferral"
                        :key="title"
                        class="language-option"
                      >
                        <InputComponent
                          :modelValue="isRbpOptionsYes && isSelected"
                          @update:modelValue="onChangeHandler"
                          :label="title"
                          type="checkbox"
                          id="dependentReferral"
                          :name="title"
                          :disabled="!isRbpOptionsYes"
                        />
                      </div>
                    </div>
                  </div>
                  <InputComponent
                    :modelValue="dependentReferralTextareaValue"
                    @update:modelValue="onChangeHandler"
                    :isTextarea="true"
                    :disabled="
                      !isRbpOptionsYes ||
                      !dependentReferral.some((obj) => obj.isSelected)
                    "
                    id="dependentReferral"
                    name="dependentReferral"
                    :helperText="
                      dependentReferral.find((obj) => obj.isSelected)
                        ? dependentReferral.find((obj) => obj.isSelected)
                            .helperText
                        : ''
                    "
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="divider"></div> -->

        <!-- <pre>{{
          JSON.stringify(
            {
              claimDetailsLanguage,
              // rbpOptions,
              //referralOptions,
              // languages: languages.filter((lang) => lang.isSelected),
              // clientName,
              // commsLibraryOptions: commsLibraryOptions.filter(
              //   (opt) => opt.isSelected
              // ),
              // administratorName: administratorName.filter(
              //   (opt) => opt.isSelected
              // ),
              // supportTeamName: supportTeamName.filter((opt) => opt.isSelected),
              // networkName: networkName.filter((opt) => opt.isSelected),
              // pcpCopay: pcpCopay.filter((opt) => opt.isSelected),
            },
            null,
            2
          )
        }}</pre> -->
      </div>
    </div>

    <div v-if="selectedTabIndex === 1" class="notifications">
      <div class="tab-action">
        <div class="tab-helper-text">
          Below you'll find all the notifications that will be auto-generated
          based on the communications library you selected. No customization to
          the content in the communications is possible. If there are any
          communications that the client would like us to NOT send, toggle the
          communication to off. Please note that a fee will be assessed to the
          client for turning off automated communications - this needs to be
          communicated to Member Communications and the Client Team to ensure
          this fee gets charged.
        </div>
        <button
          :disabled="
            Object.keys(isVaiablesFormValid).length !== 0 ||
            !getHasNotificationConfigChange
          "
          @click="handleSubmit"
        >
          Submit
        </button>
      </div>
      <div class="table-header-helper">
        <div class="subtitle">
          <P
            >{{
              selectedCommsLibraryOptions
                ? selectedCommsLibraryOptions.title + " Notifications"
                : ""
            }}
          </P>

          <!-- <p>CP Notifications</p> -->
        </div>
        <div class="eom-eoy-header">
          <p>End of month/End of year</p>
        </div>
      </div>

      <div class="alert warning" v-if="areAnyEventsOff">
        <div class="icon">
          <img src="../assets/triangle-24px.svg" alt="Centivo" />
        </div>
        <div class="content">
          <div class="title">Warning</div>
          <div class="subtitle">
            There is a fee to turn off any standard communications. Please
            notify the member communications team if a client is requesting that
            notifications be switched off.
          </div>
        </div>
      </div>

      <b-table
        :data="events"
        :bordered="true"
        :sticky-header="true"
        :height="600"
        class="grid-outer"
      >
        <b-table-column
          field="title"
          label="NOTIFICATION"
          v-slot="props"
          header-class="table-header"
          cell-class="cell"
        >
          {{ props.row.title }}
        </b-table-column>

        <b-table-column
          field="type"
          label="Type"
          v-slot="props"
          header-class="table-header"
          cell-class="cell"
        >
          {{ props.row.type }}
        </b-table-column>

        <b-table-column
          field="description"
          label="Description of event"
          v-slot="props"
          header-class="table-header"
          cell-class="cell"
        >
          {{ props.row.description }}
        </b-table-column>

        <b-table-column
          field="defaultEn"
          label="DEFAULT EN"
          v-slot="props"
          header-class="table-header"
          cell-class="cell"
        >
          {{ selectedLanguage === "English" ? props.row.defaultEn : "--" }}
        </b-table-column>

        <b-table-column
          field="defaultEnSp"
          label="DEFAULT EN - SP"
          v-slot="props"
          header-class="table-header"
          cell-class="cell"
        >
          {{ selectedLanguage === "English + Spanish" ? props.row.defaultEnSp: "--" }}
        </b-table-column>

        <b-table-column
          field="isSelected"
          label="ON/OFF"
          v-slot="props"
          header-class="table-header"
          cell-class="cell"
        >
          <!-- <json-viewer
      theme="my-awesome-json-theme"
      :value="props.row"
      :expand-depth="1"
    ></json-viewer> -->

          <div class="inline-wrapper">
            <div
              v-if="Object.keys(props.row).includes('isEOY')"
              class="radio-btn-group"
            >
              <!-- {{ props.row.isEOY ? "true" : "false" }} -->

              <div class="form-container">
                <!-- <form @submit="handleSubmit"> -->
                <form>
                  <div class="language-selector eoy-eom-selector">
                    <div class="radio-btn">
                      <label>EoM</label>
                      <input
                        type="radio"
                        :checked="props.row.isSelected && !props.row.isEOY"
                        :value="!props.row.isEOY"
                        :name="props.row.title + 'EoM'"
                        :disabled="!props.row.isSelected"
                        @input="
                          eoyChangeHandler($event, {
                            value: false,
                            eventTitle: props.row.title,
                            eventType: props.row.type,
                          })
                        "
                      />
                    </div>

                    <div class="radio-btn">
                      <label>EoY</label>
                      <input
                        type="radio"
                        :checked="props.row.isSelected && props.row.isEOY"
                        :value="props.row.isEOY"
                        :name="props.row.title + 'EoY'"
                        :disabled="!props.row.isSelected"
                        @input="
                          eoyChangeHandler($event, {
                            value: true,
                            eventTitle: props.row.title,
                            eventType: props.row.type,
                          })
                        "
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div>
              <label class="switch">
                <input type="checkbox" v-model="props.row.isSelected" />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </b-table-column>
      </b-table>
    </div>
    <!-- <pre>{{ JSON.stringify(this.commsLibraryOptions.find(com => com.isSelected) && this.commsLibraryOptions.find(com => com.isSelected).networkNames, null, 2) }}</pre> -->
    <!-- <p>
      {{
        getHasNotificationConfigChange
          ? "Form has changed"
          : "Form has same values"
      }}
    </p>
    <h2>Validation</h2> -->

    <!-- <json-viewer
      theme="my-awesome-json-theme"
      :value="isVaiablesFormValid"
      :expand-depth="1"
    ></json-viewer>
 -->

    <!-- <json-viewer
      theme="my-awesome-json-theme"
      :value="testEvent"
      :expand-depth="2"
    ></json-viewer> -->
  </div>
</template>

<script>
// import { mapActions, mapGetters } from 'vuex'
import { mapActions, mapGetters } from 'vuex'
import store from '@/store/store'
import InputComponent from './../components/form/InputComponent.vue'
import DropDownComponent from './../components/form/DropDownComponent.vue'
import initialState from './notificationConfig'
// import JsonViewer from 'vue-json-viewer'
import _ from 'lodash'

export default {
  props: { planUuid: { type: String, default: '' } },
  components: {
    InputComponent,
    DropDownComponent
    // JsonViewer
  },
  data () {
    const planBasicInfo = this.$store.getters['plans/getPlan']
    // console.log('after', planBasicInfo.notificationConfig.commsLibraryOptions.events.find(event => event.defaultEn === 'CP-2').isSelected)
    let dataObj = {

      planBasicInfo,
      selectedTabIndex: 0,
      tabs: [{ label: 'Variables' }, { label: 'Notifications' }],
      planName: planBasicInfo.planName,
      phoneNumberMemberServices: planBasicInfo.phoneNumberMemberServices ? planBasicInfo.phoneNumberMemberServices.replace(/^(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : '',
      supportHours: planBasicInfo.supportHours,
      portalUrl: planBasicInfo.portalUrl,
      //  testEvent: { test: 'true' },
      errors: {}
    }

    if (!planBasicInfo.notificationConfig) {
      // console.log('First time setting up notification config')
      dataObj = { ...dataObj, ...initialState() }
    } else {
      // converts database notifcongif schema to renderable data
      //  console.log('Editing notification config')
      let notificationConfig = planBasicInfo.notificationConfig
      const defaultNotificationConfig = initialState()

      const configureSelection = (key, selectedObject) => {
        if (selectedObject) {
          const defaultValue = defaultNotificationConfig[key]

          if (['referralOptions'].includes(key)) {
            const selectedTitles = selectedObject
              .map((obj) => obj.title)
              .join(',')

            const mergedValue = [
              ...defaultValue.filter(
                (obj) => !selectedTitles.includes(obj.title)
              ),
              ...selectedObject.map((obj) => {
                const defaultOptions = defaultValue.find(
                  (dv) => dv.title === obj.title
                )
                const selectedOptionTitles = obj.options
                  .map((o) => o.label.title)
                  .join(',')

                obj.options = [
                  ...defaultOptions.options
                    .filter(
                      (opt) => !selectedOptionTitles.includes(opt.label.title)
                    )
                    .map((obj) => {
                      obj.isSelected = false
                      return obj
                    }),
                  ...obj.options.map((obj) => {
                    obj.isSelected = true
                    // console.log(JSON.parse(JSON.stringify(obj)))
                    const matchedOption = defaultOptions.options.find(
                      (o) => o.label.title === obj.label.title
                    )
                    obj.sortOrder = matchedOption.sortOrder
                    return obj
                  })
                ].sort((a, b) => a.sortOrder - b.sortOrder)
                return obj
              })
            ].sort((a, b) => a.title.localeCompare(b.title))

            return mergedValue
          } else if (['commsLibraryOptions'].includes(key)) {
            const mergedValue = defaultValue.map((commLib) => {
              // const temp = && selectedObject.type === commLib.type

              if (
                selectedObject.title === commLib.title
              ) {
              //  console.log(selectedObject.events)
                commLib.isSelected = true

                // resolve events
                const storedEventsByKey = new Map(
                  (selectedObject.events || []).map((e) => [
                    e.title + ':' + e.type,
                    e
                  ])
                )

                commLib.events = commLib.events.map((event) => {
                  const storedEvent = storedEventsByKey.get(
                    event.title + ':' + event.type
                  )

                  if (storedEvent) {
                    event.isSelected = !!storedEvent.isSelected

                    if (storedEvent.isEOY) {
                      event.isEOY = true
                      event.defaultEn =
                        String(event.defaultEn).replace(/_EOY$/, '') + '_EOY'
                      event.defaultEnSp =
                        String(event.defaultEnSp).replace(/_EOY$/, '') + '_EOY'
                    } else {
                      event.isEOY = false
                      event.defaultEn = String(event.defaultEn).replace(
                        /_EOY$/,
                        ''
                      )
                      event.defaultEnSp = String(event.defaultEnSp).replace(
                        /_EOY$/,
                        ''
                      )
                    }
                  }

                  return event
                })
                if (selectedObject.networkNames && commLib.networkNames) {
                  const selectedNewtworkNameTitle = selectedObject.networkNames
                    .map((e) => e.title)
                    .join(',')
                  commLib.networkNames = commLib.networkNames.map(
                    (networkName) => {
                      if (
                        selectedNewtworkNameTitle.includes(networkName.title)
                      ) {
                        const selectedNetworkName =
                          selectedObject.networkNames.find(
                            (obj) => obj.title === networkName.title
                          )
                        networkName = {
                          ...selectedNetworkName,
                          isSelected: true
                        }
                      } else {
                        networkName.isSelected = false
                      }
                      return networkName
                    }
                  )
                }
              } else {
                commLib.isSelected = false
              }
              return commLib
            })
            // ...selectedObject,
            // events: defaultValue.events.map(defaultEvent => {
            //   if (unselectedEvents.includes(defaultEvent.title)) {
            //     defaultEvent.isSelected = false
            //     return defaultEvent
            //   }
            // })
            // console.log('Merged Value: ', mergedValue)
            return mergedValue
          } else {
            // console.log(`Merging ${key}`)
            const mergedValue = [
              ...defaultValue
                .filter((obj) => obj.title !== selectedObject.title)
                .map((obj1) => {
                  // turn of the default values for the unselected items
                  // delete obj1.isSelected
                  obj1.isSelected = false
                  return obj1
                }),
              {
                ...defaultValue.find(
                  (obj) => obj.title === selectedObject.title
                ),
                ...selectedObject,
                isSelected: true
              } // TODO sort key need to be added back from default value
            ].sort((a, b) => a.title.localeCompare(b.title))
            //   console.log(mergedValue)
            return mergedValue
          }
        }
        return defaultNotificationConfig[key]
      }

      // console.log('lets merge the notication to default config')
      notificationConfig = {
        clientName: notificationConfig.clientName,
        languages: configureSelection(
          'languages',
          notificationConfig.languages
        ),
        commsLibraryOptions: configureSelection(
          'commsLibraryOptions',
          notificationConfig?.commsLibraryOptions
        ),
        administratorName: configureSelection(
          'administratorName',
          notificationConfig.administratorName
        ),
        supportTeamName: configureSelection(
          'supportTeamName',
          notificationConfig.supportTeamName
        ),
        networkName: configureSelection(
          'networkName',
          notificationConfig?.networkName
        ),
        pcpCopay: configureSelection('pcpCopay', notificationConfig.pcpCopay),

        referralOptions: configureSelection(
          'referralOptions',
          notificationConfig.referralOptions
        ), // defaultNotificationConfig.referralOptions || notificationConfig.referralOptions.filter(refOption => refOption.options.some(o => o.isSelected)),

        rbpOptions: configureSelection(
          'rbpOptions',
          notificationConfig.rbpOptions
        ).sort((a, b) => b.title.localeCompare(a.title)),
        // events: configureSelection('events', notificationConfig.events),

        // TODO for these 3 not sure if we need to pass all or just selected ones
        claimDetailsLanguage: configureSelection(
          'claimDetailsLanguage',
          notificationConfig.claimDetailsLanguage
        ).sort((a, b) => a.sortOrder - b.sortOrder),
        selfReferral: configureSelection(
          'selfReferral',
          notificationConfig.selfReferral
        ).sort((a, b) => a.sortOrder - b.sortOrder),
        dependentReferral: configureSelection(
          'dependentReferral',
          notificationConfig.dependentReferral
        ).sort((a, b) => a.sortOrder - b.sortOrder)
      }

      // TODO look thru object keys and replace the isSelected object in most case some have name as key and some have title
      dataObj = { ...dataObj, ...notificationConfig, resetSearchText: false }
    }

    return dataObj
  },
  mounted () {
    this.selectTab(0)
    this.saveOriginalData(this.$data)
  },
  beforeDestroy () {
    Object.assign(this.$data, initialState())
    // this.$store.commit('setHasNotificationConfigChange', false)
    this.updateHasNotificationConfigChange(false)
    this.updateShowWarningModal(false)
  },
  computed: {
    // ...mapState({
    //   message: state => state.obj.message
    // }),
    ...mapGetters(['getShowWarningModal', 'getHasNotificationConfigChange']),
    isPcpCopaySelected () {
      return !this.pcpCopay.some((pcpC) => pcpC.isSelected)
    },
    isRbpOptionsYes () {
      return (
        this.rbpOptions.find((rbpOpt) => rbpOpt.isSelected)?.title === 'Yes'
      )
    },
    isPartnershipPlan () {
      const selectedCommsLib =
        this.commsLibraryOptions?.find((commsLib) => commsLib.isSelected) || {}
      return (
        selectedCommsLib.isPartnershipPlan || selectedCommsLib.title === 'Cone'
      )
    },
    textCode () {
      return (
        this.administratorName.find((adminName) => adminName.isSelected)
          ?.textCode || ''
      )
    },
    textWord () {
      return this.administratorName.find((adminName) => adminName.isSelected)
        ?.textWord
    },
    networkNames () {
      return (
        this.commsLibraryOptions?.find((commsLib) => commsLib.isSelected)
          ?.networkNames || []
      )
    },
    events () {
      const selectedLibrary = this.commsLibraryOptions?.find((commsLib) => commsLib.isSelected)

      const events = selectedLibrary?.events || []
      const networkNames = selectedLibrary?.networkNames?.find(n => n.isSelected)

      // dynamic templates based on network name selection
      events.forEach(e => {
        if (e.templates) {
          const overwriteDefaultEn = e.templates.find(t => t.networkFilters.includes(networkNames.title) && t.language === 'English')
          const defaultEn = e.templates.find(t => t.language === 'English')
          if (overwriteDefaultEn) {
            e.defaultEn = overwriteDefaultEn.title
          } else if (e.defaultEn !== defaultEn.default) {
            e.defaultEn = defaultEn.default
          }
          const overwriteDefaultEnSp = e.templates.find(t => t.networkFilters.includes(networkNames.title) && t.language === 'English + Spanish')
          const defaultEnSp = e.templates.find(t => t.language === 'English + Spanish')
          if (overwriteDefaultEnSp) {
            e.defaultEnSp = overwriteDefaultEnSp.title
          } else if (e.defaultEnSp !== defaultEnSp.default) {
            e.defaultEnSp = defaultEnSp.default
          }
        }
      })
      const commsLibrary = this.commsLibraryOptions?.find((commsLib) => commsLib.isSelected)

      // filter out COB for now for ALL comms libraries (CENG-453)
      commsLibrary.events = commsLibrary?.events.filter(event => event.title !== 'cobReminder')

      // filter out HPS events from TPA comms library with non-HPS network
      if (commsLibrary?.title === 'TPA' && commsLibrary?.networkNames?.find(network => network.isSelected === true && network.title !== 'HPS')) {
        return commsLibrary.events.filter(event => event.title !== 'newMemberHpsEoB')
      }

      // filter out COB for now (CENG-453)
      return (commsLibrary?.events.filter(event => event.title !== 'cobReminder') || [])
    },
    selectedLanguage () {
      return this.languages.find((lang) => lang.isSelected)?.title
    },
    selectedCommsLibraryOptions () {
      return this.commsLibraryOptions?.find((commsLib) => commsLib.isSelected)
    },
    claimDetailsLanguageTextareaValue () {
      return this.claimDetailsLanguage.find((obj) => obj.isSelected)?.value
    },
    selfReferralTextareaValue () {
      return this.selfReferral.find((obj) => obj.isSelected)?.value
    },
    dependentReferralTextareaValue () {
      return this.dependentReferral.find((obj) => obj.isSelected)?.value
    },
    isVaiablesFormValid () {
      const validatiaonErrors = {}
      if (!this.languages.find((obj) => obj.isSelected)) {
        validatiaonErrors.languages = 'Language is required'
      }

      if (!this.clientName) {
        validatiaonErrors.clientName = 'Client name is required'
      }

      if (!this.administratorName.find((obj) => obj.isSelected)) {
        validatiaonErrors.administratorName = 'Adminitstrator Name is required'
      }

      if (!this.supportTeamName.find((obj) => obj.isSelected)) {
        validatiaonErrors.supportTeamName = 'Support Team Name is required'
      }

      const selectedCommsLib = this.commsLibraryOptions.find(
        (obj) => obj.isSelected
      )

      if (selectedCommsLib) {
        if (
          selectedCommsLib.isPartnershipPlan ||
          selectedCommsLib.title === 'Cone'
        ) {
          if (!this.pcpCopay?.find((obj) => obj.isSelected)) {
            validatiaonErrors.pcpCopay = 'PCP copay is required'
          } else if (
            this.pcpCopay?.find((obj) => obj.isSelected).title === 'Other' &&
            !this.pcpCopay?.find((obj) => obj.isSelected).value
          ) {
            validatiaonErrors.pcpCopay = 'PCP copay other requires an input'
          }

          if (
            !this.referralOptions.every(({ options }) =>
              options.some((opt) => opt.isSelected && opt.value)
            )
          ) {
            validatiaonErrors.referralOptions = 'Referral option is requried'
          }
        } else {
          // if (!this.rbpOptions.find((obj) => obj.isSelected)) {
          //   validatiaonErrors.rbpOptions = 'RBP option is requried'
          // }

          if (
            selectedCommsLib.networkNames &&
            !selectedCommsLib.networkNames.find((obj) => obj.isSelected)
          ) {
            validatiaonErrors.commsLibraryOptions = {
              networkNames: 'Networkname is required'
            }
          } else if (
            selectedCommsLib.networkNames.find((obj) => obj.isSelected)
              .title === 'Other' &&
            !selectedCommsLib.networkNames.find((obj) => obj.isSelected).value
          ) {
            validatiaonErrors.commsLibraryOptions = {
              networkNames:
                'Networkname input is requried if others is selected'
            }
          }
          // console.log(selectedCommsLib.networkNames && selectedCommsLib.networkNames.find((obj) => obj.isSelected)?.value)
        }
        // RBP can be configured for all comms lib
        if (!this.rbpOptions.find((obj) => obj.isSelected)) {
          validatiaonErrors.rbpOptions = 'RBP option is requried'
        } else if (
          this.rbpOptions.find((obj) => obj.isSelected).title === 'No'
        ) {
          // do nothing
        } else {
          // claimsDtailsLanguage validation
          const selectedClaimsDetailsLanguage =
            this.claimDetailsLanguage.find((opt) => opt.isSelected) || {}
          if (selectedClaimsDetailsLanguage.title === 'N/A') {
            // skip validation
          } else {
            if (!selectedClaimsDetailsLanguage.value) {
              validatiaonErrors.claimDetailsLanguage =
                'Claim details language is required'
            }
          }

          // self referral validation
          const selectedSelfReferral =
            this.selfReferral.find((opt) => opt.isSelected) || {}

          if (selectedSelfReferral.title === 'N/A') {
            // skip validation
          } else {
            if (!selectedSelfReferral.value) {
              validatiaonErrors.selfReferral = 'SelfReferral is requried'
            }
          }

          // dependent referral validation
          const selectedDependentReferral =
            this.dependentReferral.find((opt) => opt.isSelected) || {}

          if (selectedDependentReferral.title === 'N/A') {
            // skip validation
          } else {
            if (!selectedDependentReferral.value) {
              validatiaonErrors.dependentReferral =
                'Dependent Referral is requried'
            }
          }
        }
      } else {
        validatiaonErrors.commsLibraryOptions =
          'Communication Library Options is requried'
      }

      return validatiaonErrors
    },
    areAnyEventsOff () {
      return this.commsLibraryOptions
        ?.find((cl) => cl.isSelected)
        ?.events?.some((e) => !e.isSelected)
    },
    todos () {
      // console.log(this.$store.state.jobsModule.todos);
      return this.$store.state.notifications.todos
    }
    //  referralOptionsComputed () {
    //  return this.referralOptions
    // }
  },
  watch: {
    $data: {
      handler: 'updatePlanNotificationConfig',
      // handler: (val, oldVal) => {
      //   this.updatePlanNotificationConfig(val)
      // },
      deep: true
    }
  },
  methods: {
    //  ...mapGetters(['getDefaultNotificationConfig']),
    ...mapActions([
      'updateNotificationConfigByClientIdandPlanId',
      'getDefaultNotificationConfig',
      'updateHasNotificationConfigChange',
      'updateShowWarningModal'
    ]),
    eoyChangeHandler (actualEvent, e) {
      // console.log(e)
      // console.log(e.target.name)
      // console.log(e.target.value)
      // console.log(e.target.id)
      this.commsLibraryOptions = this.commsLibraryOptions.map((clo) => {
        if (clo.isSelected) {
          clo.events = clo.events.map((event) => {
            if (event.title === e.eventTitle && event.type === e.eventType) {
              event.isEOY = e.value
              if (e.value) {
                event.defaultEn = event.defaultEn + '_EOY'
                event.defaultEnSp = event.defaultEnSp + '_EOY'
              } else {
                event.defaultEn = event.defaultEn.replaceAll('_EOY', '')
                event.defaultEnSp = event.defaultEnSp.replaceAll('_EOY', '')
              }
            }
            return event
          })
        }
        return clo
      })
    },
    goHome () {
      const toPath = this.getShowWarningModal && this.getShowWarningModal.length ? this.getShowWarningModal : '/plans'

      this.updateHasNotificationConfigChange(false)
      this.updateShowWarningModal(false)

      this.$router.push({ path: toPath }).catch(() => {})
    },
    handleModelClick (e) {
      console.log(e)
      const modal = document.getElementById('modal-warning')
      // eslint-disable-next-line eqeqeq
      if (e.target == modal) {
        // modal.style.display = 'none'
        this.updateShowWarningModal(false)
      }
    },
    saveOriginalData (data) {
      this.originalNetworkConfig = JSON.parse(JSON.stringify(data))
    },
    updatePlanNotificationConfig (value, oldValue) {
      //  console.log('in notificationsetup updatePlanNotificationConfig')
      // this.$store.commit('setPlanNotificationConfig', value)
      const rawNewValue = JSON.parse(JSON.stringify(value))
      const rawOriginalValue = JSON.parse(
        JSON.stringify(this.originalNetworkConfig)
      )

      delete rawNewValue.tabs
      delete rawOriginalValue.tabs

      delete rawNewValue.selectedTabIndex
      delete rawOriginalValue.selectedTabIndex

      delete rawNewValue.errors
      delete rawOriginalValue.errors

      delete rawNewValue.planBasicInfo
      delete rawOriginalValue.planBasicInfo

      const hasChanged = Object.keys(rawOriginalValue).some((attr) => {
        const orgValue = rawOriginalValue[attr]
        const newValue = rawNewValue[attr]

        if (_.isEqual(orgValue, newValue)) {
          // console.log(`${attr} are equal`)
          return false
        } else {
          // console.log('--------')
          // console.log(`${attr} are not equal`)
          // console.log(orgValue)
          // console.log(newValue)
          return true
        }
      })
      this.updateHasNotificationConfigChange(hasChanged)
      //   this.$store.commit('setHasNotificationConfigChange', hasChanged)
    },
    updateMessage (e) {
      this.$store.commit('updateMessage', e.target.value)
    },
    selectTab (i) {
      this.selectedTabIndex = i

      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i
      })
    },
    customInputInDropDownHandler (event) {
      if (event.target.name === 'networkNames') {
        this.commsLibraryOptions.find((cl) => cl.isSelected).networkNames =
          this.commsLibraryOptions
            .find((cl) => cl.isSelected)
            .networkNames.map((netName) => {
              if (netName.title === 'Other') {
                // console.log(netName.value)
                // console.log(event.target.value)
                netName.value = event.target.value.trim()
                //  this.networkName = event.target.value.trim()
              }
              return netName
            })

        // console.log(this.commsLibraryOptions.networkNames.find((cl) => cl.isSelected))
      }

      if (event.target.name === 'pcpCopay') {
        this.pcpCopay = this.pcpCopay.map((opt) => {
          if (opt.title === 'Other') {
            opt.value = event.target.value.trim()
          }
          return opt
        })
      }
    },
    onChangeHandler (event) {
      //  console.log('onchangehandler')
      // console.log('type : ' + event.target.type)
      // console.log('name : ' + event.target.name)
      // console.log('id : ' + event.target.id)
      // console.log('value : ' + event.target.value)

      // add validation for all field here

      // clear erros
      this.errors = { ...this.errors, [event.target.name]: false }

      if (event.target.type === 'checkbox') {
        if (
          [
            'languages',
            'rbpOptions',
            'claimDetailsLanguage',
            'selfReferral',
            'dependentReferral'
          ].includes(event.target.id)
        ) {
          this[event.target.id] = this[event.target.id].map((obj) => {
            if (obj.title === event.target.name && !obj.isSelected) {
              obj.isSelected = true
            } else {
              // delete obj.isSelected
              obj.isSelected = false
            }
            // console.log(obj)
            return obj
          })
        } else if (event.target.id && event.target.id.includes('Referral')) {
          this.referralOptions = this.referralOptions.map((ref) => {
            if (event.target.id === ref.title) {
              ref.options = ref.options.map((opt) => {
                //  console.log(opt.isSelected)
                if (opt.label.title === event.target.name && !opt.isSelected) {
                  opt.isSelected = true
                } else {
                  //     delete opt.isSelected
                  opt.isSelected = false
                  //   delete opt.value
                }
                return opt
              })
            }
            return ref
          })
        } else {
          // works for true and false
          this[event.target.name] = !this[event.target.name]
        }
      } else if (event.target.type === 'dropdown') {
        if (event.target.id) {
          // console.log()
        } else if (event.target.name === 'networkNames') {
          this.resetSearchText = false
          this.commsLibraryOptions = this.commsLibraryOptions.map(
            (commsLib) => {
              if (commsLib.isSelected) {
                commsLib.networkNames && commsLib.networkNames.map((opt) => {
                  if (opt.title === event.target.value) {
                    opt.isSelected = true
                  } else {
                    opt.isSelected = false
                  }
                })
              }
              return commsLib
            }
          )
        } else {
          this[event.target.name] = this[event.target.name].map((opt) => {
            if (opt.title === event.target.value) {
              opt.isSelected = true

              if (event.target.name === 'commsLibraryOptions') {
                this.resetSearchText = true
              }
            } else {
              opt.isSelected = false
            }

            return opt
          })
        }
      } else if (event.target.type === 'textarea') {
        if (
          [
            'claimDetailsLanguage',
            'selfReferral',
            'dependentReferral'
          ].includes(event.target.id)
        ) {
          this[event.target.id] = this[event.target.id].map((obj) => {
            if (obj.isSelected) {
              obj.value = event.target.value.trim()
            }
            return obj
          })
        }
      } else {
        if (event.target.id && event.target.id.includes('Referral')) {
          this.referralOptions = this.referralOptions.map((ref) => {
            if (event.target.id === ref.title) {
              ref.options = ref.options.map((opt) => {
                if (opt.isSelected) {
                  opt.value = event.target.value.trim()
                }
                return opt
              })
            }
            return ref
          })
        } else {
          this[event.target.name] = event.target.value.trim()
        }
      }
    },
    findAndCleanData (array) {
      const objNoReference = JSON.parse(JSON.stringify(array))
      const data = objNoReference.find((obj) => obj.isSelected)
      if (data) {
        delete data.isSelected
        delete data.sortOrder
        if (data.networkNames) {
          data.networkNames = data.networkNames.filter(
            (networkName) => networkName.isSelected
          )
        }
      }

      return data
    },
    async handleSubmit (e) {
      e.preventDefault()
      // clean up data and persist to plan

      // const findAndCleanData = (array) => {
      //   const objNoReference = JSON.parse(JSON.stringify(array))
      //   const data = objNoReference.find((obj) => obj.isSelected)
      //   if (data) {
      //     delete data.isSelected
      //     delete data.sortOrder
      //   }
      //   if (data.events) {
      //     data.events = data.events.filter(event => !event.isSelected)
      //   }
      //   return data
      // }

      // Set HPS notifications to false if comms library is TPA and non-HPS network
      const commsLibrary = this.commsLibraryOptions?.find((commsLib) => commsLib.isSelected)
      if (commsLibrary?.title === 'TPA' && commsLibrary?.networkNames?.find(network => network.isSelected === true && network.title !== 'HPS')) {
        commsLibrary.events = commsLibrary.events.map(event => {
          if (event.title === 'newMemberHpsEoB') {
            event.isSelected = false
          }
          return event
        })
      }
      const notificationConfig = {
        // createdDate and updatedDate is handled in the backend
        updatedBy: store.getters['auth/getUsername'],
        ...this.planBasicInfo.notificationConfig,
        clientName: this.clientName,
        languages: this.findAndCleanData(this.languages),
        commsLibraryOptions: this.findAndCleanData(this.commsLibraryOptions),
        administratorName: this.findAndCleanData(this.administratorName),
        supportTeamName: this.findAndCleanData(this.supportTeamName),
        // networkName: this.findAndCleanData(this.networkName),
        pcpCopay: this.findAndCleanData(this.pcpCopay),
        referralOptions: JSON.parse(JSON.stringify(this.referralOptions))
          .filter(
            (refOption) =>
              refOption.options && refOption.options.some((o) => o.isSelected)
          )
          .map((refOption1) => {
            refOption1.options = refOption1.options.filter(
              (opt) => opt.isSelected
            )
            // .map((o) => {
            //   // delete o.isSelected
            //   // delete o.sortOrder
            //   o.isSelected = false
            //   return o
            // })
            return refOption1
          }),
        rbpOptions: this.findAndCleanData(this.rbpOptions), // .find((rbp) => rbp.isSelected),
        // events: JSON.parse(JSON.stringify(this.events))
        //   .filter((e) => !e.isSelected)
        //   .map((e1) => {
        //     // e1.isOff = true
        //     // delete e1.isSelected
        //     return e1
        //   }), // all events are turned on by default
        // TODO  for these 3 not sure if we need to pass all or just selected ones
        claimDetailsLanguage: this.findAndCleanData(this.claimDetailsLanguage),
        selfReferral: this.findAndCleanData(this.selfReferral),
        dependentReferral: this.findAndCleanData(this.dependentReferral)
      }

      if (notificationConfig.rbpOptions.title === 'No') {
        delete notificationConfig.claimDetailsLanguage
      }
      // remove undefined attributes
      Object.keys(notificationConfig).forEach((key) => {
        if (notificationConfig[key] === undefined) {
          delete notificationConfig[key]
        }
      })

      // console.log({
      //   clientId: this.planBasicInfo.clientId,
      //   planId: this.planBasicInfo.planId,
      //   notificationConfig
      // })
      const tableSourceType = store.getters['plans/getTableSourceType']
      if (tableSourceType === 'JAVELINA') {
        await this.updateNotificationConfigByClientIdandPlanId({
          clientId: this.planBasicInfo.clientId,
          planId: this.planBasicInfo.planId,
          notificationConfig
        })
      } else {
        await this.updateNotificationConfigByClientIdandPlanId({
          clientId: this.planBasicInfo.clientId,
          planId: this.planBasicInfo.planId,
          notificationConfig
        })
      }
      this.updateHasNotificationConfigChange(false)
      this.updateShowWarningModal(false)
      //  this.$store.commit('setHasNotificationConfigChange', false)

      this.$buefy.toast.open({
        message: 'Notification saved successfully!',
        type: 'is-success',
        duration: 5000,
        position: 'is-top'
      })

      this.$router.push({ path: '/plans' })
    },
    updateClaimDetailsLanguageTitle (title) {
      switch (title) {
        case 'Payer Compass and Asserta Health language':
          title = 'Asserta Health language'
          break
        default:
          break
      }
      return title
    }
  }
}
</script>
